import { RestClient } from '@/api/rest-client'
import { RealworksCredentials } from '@/api/model/credentials'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { User } from '@/api/model/user'
import { Branch } from '@/api/model/branch'

export interface RealworksCredentialsValidationResult {
    basic: boolean
    facturen: boolean
    objecten: boolean
    agenda: boolean
    taken: boolean
    relaties: boolean
}

export class RealworksCredentialsClient extends RestClient<RealworksCredentials> {
    collectionName = 'realworks_credentials'
    parseData = RealworksCredentials.fromData

    private buildData(data: any): any {
        if (data.company instanceof Company) {
            data.company = data.company.resourceIdentifier
        }

        if (data.createdBy instanceof User) {
            data.user = data.createdBy.resourceIdentifier
            delete data.createdBy
        }

        if (data.updatedBy instanceof User) {
            data.user = data.updatedBy.resourceIdentifier
            delete data.updatedBy
        }

        if (data.agendaBranch instanceof Branch) {
            data.agendaBranch = data.agendaBranch.resourceIdentifier
        }

        return data
    }

    async create(credentials: RealworksCredentials): Promise<RealworksCredentials> {
        return super.create(
            this.buildData(credentials),
        )
    }

    async update(id: string, credentials: RealworksCredentials): Promise<RealworksCredentials> {
        return super.update(
            id,
            this.buildData(credentials),
        )
    }

    async validate(credentials: RealworksCredentials): Promise<RealworksCredentialsValidationResult> {
        const response = await this.client.post(`${this.basePath}/service/realworks/validate_credentials`, {
            apiKey: credentials.apiKey,
        })

        return response.data as RealworksCredentialsValidationResult
    }
}
